import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TdcApplicationState } from 'src/app/models/state/tdc-application-state.model';

export const selectTdcApplicationState =
	createFeatureSelector<TdcApplicationState>('tdcApplication');
export const selectDefaultTdcCard = createSelector(
	selectTdcApplicationState,
	tdcApplicationState => {
		return tdcApplicationState.evaluation?.approvedCards.find(
			tdcCard => tdcCard.isDefault
		);
	}
);

export const selectApprovedCard = createSelector(
	selectTdcApplicationState,
	selectDefaultTdcCard,
	(tdcApplicationState, defaultTdcCard) => {
		if (tdcApplicationState?.evaluation?.hasAnyCardApprobed) {
			if (defaultTdcCard.creditLine > 0) {
				return defaultTdcCard;
			}

			return tdcApplicationState?.evaluation?.approvedCards.find(
				tdcCard => tdcCard.creditLine > 0
			);
		}
	}
);

export const selectHasSavedDebitCardOption = createSelector(
	selectTdcApplicationState,
	tdcApplicationState => {
		return tdcApplicationState.hasSavedDebitCardOption;
	}
);
